import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';
import { getCatalog, getCategoryBySlugOrId, getSubcategoryPage } from '~/entities/catalog/api';
import { categoryIdFromSubcategoryId } from '~/entities/catalog/paths';
import { withGlobalSearch } from '~/entities/catalog/url-search';

const searchSchema = withGlobalSearch({
  sub: z.string().optional(),
  item: z.string().optional(),
  child: z.string().optional(),
});

/** Legacy flat subcategory URL → nested under category (English slugs when available). */
export const Route = createFileRoute('/subcategory/$id')({
  validateSearch: searchSchema,
  beforeLoad: async ({ params, search }) => {
    await getCatalog();
    const page = await getSubcategoryPage(params.id);
    const categoryId = page?.categoryId ?? categoryIdFromSubcategoryId(params.id);
    const category = await getCategoryBySlugOrId(categoryId);
    throw redirect({
      to: '/categories/$categoryId/$subcategoryId',
      params: {
        categoryId: category?.slug ?? categoryId,
        subcategoryId: page?.slug ?? params.id,
      },
      search,
      replace: true,
    });
  },
});
